import React, { InputHTMLAttributes, ReactElement } from 'react';
import { Theme } from '../../../config/config.types';
import { State } from '../types';

type HTMLElementType = InputHTMLAttributes<HTMLInputElement>;

export { Theme, State };

export enum IconPosition {
  LEFT = 'left',
  RIGHT = 'right',
}

export type Mode = 'primary' | 'secondary';

export interface StyledProps extends HTMLElementType {
  state?: State;
  mode?: Mode;
  showEllipsis?: boolean;
  noMaxHeight?: boolean;
}

export interface ComponentProps extends StyledProps {
  leftIcon?: (stateColor: string) => ReactElement;
  rightIcon?: (stateColor: string) => ReactElement;
  beforeInput?: ReactElement;
}
